// extracted by mini-css-extract-plugin
module.exports = {"container":"_osSjHA8q","longDebtContainer":"_tB4AC7ie","content":"_J85hN_Sz","rightContent":"_aqRWNg_3","alignRight":"_0ySbdldS","badge":"_fRXPKXX_","decoratedText":"_rlOTAmrG"};